var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "collect-invoice-window",
      staticStyle: { padding: "10px 20px" }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            inline: true,
            "label-width": "120px",
            "label-position": "left"
          }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "row" } },
            [
              _c("div", { staticStyle: { flex: "1" } }, [
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "padding-bottom3",
                        attrs: { label: _vm.$t("Invoice.invoice_invoiceNo") }
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: _vm.properties.invoice.invoiceNo,
                            callback: function($$v) {
                              _vm.$set(_vm.properties.invoice, "invoiceNo", $$v)
                            },
                            expression: "properties.invoice.invoiceNo"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "padding-bottom3",
                        attrs: {
                          label: _vm.$t("Invoice.invoice_invoicingDate")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "170px" },
                          attrs: {
                            type: "date",
                            clearable: false,
                            disabled: _vm.locked
                          },
                          on: { change: _vm.invoiceDateChange },
                          model: {
                            value: _vm.properties.invoice.invoiceDate,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.properties.invoice,
                                "invoiceDate",
                                $$v
                              )
                            },
                            expression: "properties.invoice.invoiceDate"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "padding-bottom": "3px" },
                        attrs: {
                          label: _vm.$t("Invoice.invoice_invoiceHeader"),
                          "label-width": "120px"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "240px" },
                          attrs: {
                            "select-type":
                              _vm.selectTypeNames.static_data_Title,
                            "allow-create": true,
                            filterable: "",
                            cache: false,
                            "default-value": _vm.properties.invoice.title,
                            "static-options": _vm.customerTitles
                          },
                          on: { parentCallBack: _vm.apTitleChangeEvent }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { "padding-bottom": "3px" },
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_ReceiptInvoiceTitle"),
                          "label-width": "120px"
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "240px" },
                          attrs: {
                            no: "receiptInvoiceTitle",
                            "select-type":
                              _vm.selectTypeNames.static_data_InvoiceTitle,
                            "allow-create": true,
                            filterable: "",
                            cache: false,
                            "default-value":
                              _vm.properties.invoice.receiptInvoiceTitle,
                            "static-options": _vm.ourInvoiceTitleArray
                          },
                          on: {
                            parentCallBack: _vm.apReceiptInvoiceTitleChangeEvent
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "padding-bottom3",
                        attrs: { label: _vm.$t("Invoice.invoice_exchangeRate") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "170px" },
                          attrs: { disabled: true },
                          model: {
                            value: _vm.rate,
                            callback: function($$v) {
                              _vm.rate = $$v
                            },
                            expression: "rate"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "padding-bottom3",
                        attrs: { label: _vm.$t("Invoice.invoice_totalAmount") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "170px" },
                          attrs: { disabled: true },
                          model: {
                            value: _vm.properties.invoice.chineseAmount,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.properties.invoice,
                                "chineseAmount",
                                $$v
                              )
                            },
                            expression: "properties.invoice.chineseAmount"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "padding-bottom3",
                        attrs: { label: _vm.$t("Invoice.invoice_total") }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("el-input-number", {
                              staticStyle: { width: "170px" },
                              attrs: {
                                disabled: true,
                                precision: 2,
                                step: 1,
                                min: -999999999999,
                                max: 999999999999,
                                "controls-position": "right"
                              },
                              model: {
                                value: _vm.properties.invoice.amount,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.properties.invoice,
                                    "amount",
                                    $$v
                                  )
                                },
                                expression: "properties.invoice.amount"
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "padding-bottom3",
                        attrs: {
                          label: _vm.$t("Invoice.invoice_taxFreeAmount")
                        }
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "170px" },
                          attrs: {
                            disabled: true,
                            precision: 2,
                            step: 1,
                            min: -999999999999,
                            max: 999999999999,
                            "controls-position": "right"
                          },
                          model: {
                            value: _vm.properties.invoice.excludingTaxAmount,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.properties.invoice,
                                "excludingTaxAmount",
                                $$v
                              )
                            },
                            expression: "properties.invoice.excludingTaxAmount"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.eiTaxControlInterfaceName === "NUONUO"
                  ? _c(
                      "div",
                      { staticClass: "el-form-item-wrapper" },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "padding-bottom3",
                            attrs: {
                              label: _vm.$t("CargoMsg.Cargo_InvoiceNature")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              staticStyle: { width: "170px" },
                              attrs: {
                                no: "invoiceNature",
                                filterable: "",
                                cache: false,
                                "default-value":
                                  _vm.properties.invoice.invoiceNature,
                                "static-options": _vm.INVOICE_NATURE,
                                "tag-value": "code",
                                "tag-name": _vm.isZh
                                  ? "chineseName"
                                  : "englishName"
                              },
                              on: {
                                parentCallBack: _vm.apInvoiceNatureChangeEvent
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "padding-bottom3",
                        attrs: { label: _vm.$t("Invoice.billingJob_taxRate") }
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "170px" },
                          attrs: {
                            disabled: _vm.apTaxRateReadonly,
                            precision: 2,
                            step: 1,
                            min: 0,
                            max: 100,
                            "controls-position": "right"
                          },
                          on: { change: _vm.taxRateChangeHandler },
                          model: {
                            value: _vm.properties.invoice.taxRate,
                            callback: function($$v) {
                              _vm.$set(_vm.properties.invoice, "taxRate", $$v)
                            },
                            expression: "properties.invoice.taxRate"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "padding-bottom3",
                        attrs: { label: _vm.$t("Invoice.invoice_taxAmount") }
                      },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "170px" },
                          attrs: {
                            precision: 2,
                            step: 1,
                            min: -999999999999,
                            max: 999999999999,
                            "controls-position": "right"
                          },
                          on: { change: _vm.taxAmountChangeHandler },
                          model: {
                            value: _vm.properties.invoice.taxAmount,
                            callback: function($$v) {
                              _vm.$set(_vm.properties.invoice, "taxAmount", $$v)
                            },
                            expression: "properties.invoice.taxAmount"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "padding-bottom3",
                        attrs: { label: _vm.$t("Invoice.invoice_approvedBy") }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "170px" },
                          attrs: { disabled: true },
                          model: {
                            value: _vm.properties.invoice.auditor,
                            callback: function($$v) {
                              _vm.$set(_vm.properties.invoice, "auditor", $$v)
                            },
                            expression: "properties.invoice.auditor"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "padding-bottom3",
                        attrs: {
                          label: _vm.$t("Invoice.invoice_actualReceiptDate")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "170px" },
                          attrs: { disabled: _vm.locked, type: "date" },
                          model: {
                            value: _vm.properties.invoice.actualReceiptDate,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.properties.invoice,
                                "actualReceiptDate",
                                $$v
                              )
                            },
                            expression: "properties.invoice.actualReceiptDate"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "padding-bottom3-left40",
                        attrs: { label: _vm.$t("Payment.paymentPeriod") }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "170px" },
                          attrs: {
                            disabled: _vm.locked,
                            no: "paymentTerm",
                            type: "date",
                            placeholder: _vm.incomePayDate
                          },
                          model: {
                            value: _vm.properties.invoice.paymentTerm,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.properties.invoice,
                                "paymentTerm",
                                $$v
                              )
                            },
                            expression: "properties.invoice.paymentTerm"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "padding-bottom3",
                        attrs: {
                          label: _vm.$t("Invoice.invoice_notesOnReceipt")
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "170px" },
                          attrs: {
                            disabled: _vm.locked,
                            type: "textarea",
                            resize: "none"
                          },
                          model: {
                            value: _vm.properties.invoice.remark,
                            callback: function($$v) {
                              _vm.$set(_vm.properties.invoice, "remark", $$v)
                            },
                            expression: "properties.invoice.remark"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "padding-bottom3-left40",
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_FinancialRemarks")
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "170px" },
                          attrs: {
                            disabled: _vm.locked,
                            type: "textarea",
                            resize: "none"
                          },
                          model: {
                            value: _vm.properties.invoice.remark2,
                            callback: function($$v) {
                              _vm.$set(_vm.properties.invoice, "remark2", $$v)
                            },
                            expression: "properties.invoice.remark2"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }